/**
 * The marketing site's category colour ramp: teal hsl(193 63% 50%) at t = 0 to
 * violet hsl(282 45% 42%) at t = 1. The homepage carousel and the Features
 * page both colour Launch → Collaborate along it, so a category reads as the
 * same colour on both pages.
 */
export const categoryColor = (t: number, alpha = 1) =>
  `hsl(${193 + (282 - 193) * t} ${63 + (45 - 63) * t}% ${50 + (42 - 50) * t}% / ${alpha})`;

/** The two-stop gradient used for a category's icon tiles. */
export const categoryGradient = (t: number) =>
  `linear-gradient(135deg, ${categoryColor(t)}, ${categoryColor(Math.min(1, t + 0.25))})`;

/**
 * The same hue lifted for text and icons on the dark bands and cards: the
 * middle and violet end of the ramp sit at ~2.2–2.7:1 on the dark canvas, this
 * lifts every step past 4.5:1. Use categoryColor for fills, this for ink.
 */
export const categoryInkOnDark = (t: number, alpha = 1) =>
  `hsl(${193 + (282 - 193) * t} ${63 + (45 - 63) * t}% ${50 + (42 - 50) * t + 24}% / ${alpha})`;

/**
 * The ramp darkened for white TEXT on a filled badge (step numbers): the
 * plain gradient's teal end gives white text only ~2.6:1, this keeps every
 * point of the gradient at ≥ 4.75:1.
 */
const BADGE_DARKEN = 14;
const categoryBadgeColor = (t: number) =>
  `hsl(${193 + (282 - 193) * t} ${63 + (45 - 63) * t}% ${50 + (42 - 50) * t - BADGE_DARKEN}%)`;
export const categoryBadgeGradient = (t: number) =>
  `linear-gradient(135deg, ${categoryBadgeColor(t)}, ${categoryBadgeColor(Math.min(1, t + 0.25))})`;
